import { DateTime } from "luxon";

export const ACTIVITY_TIMEFRAME_OPTIONS = [
  { label: "Last 7 Days", value: "last7days" },
  { label: "Last 30 Days", value: "last30days" },
  { label: "Last 6 Months", value: "last6months" },
  { label: "This Year", value: "thisyear" },
  { label: "Last Year", value: "lastyear" },
  { label: "Custom Range", value: "customrange" },
] as const;

export type ActivityTimeframeValue =
  (typeof ACTIVITY_TIMEFRAME_OPTIONS)[number]["value"];

export interface ActivityDateRange {
  from: DateTime | null;
  to: DateTime | null;
}

export const calculateActivityDateRange = (
  value: ActivityTimeframeValue,
): ActivityDateRange => {
  const today = DateTime.now();

  const ranges: Record<ActivityTimeframeValue, ActivityDateRange> = {
    last7days: { from: today.minus({ days: 7 }), to: null },
    last30days: { from: today.minus({ days: 30 }), to: null },
    last6months: { from: today.minus({ months: 6 }), to: null },
    thisyear: { from: today.startOf("year"), to: null },
    lastyear: {
      from: today.minus({ years: 1 }).startOf("year"),
      to: today.minus({ years: 1 }).endOf("year"),
    },
    customrange: { from: null, to: null },
  };

  return ranges[value];
};
